<template>
  <div id="paginaAnagraficaUnica">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Grid View: GridElencoSoggetti -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Soggetti Anagrafica Unica</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown
              variant="link"
              no-caret
              right
              class="chart-dropdown"
              toggle-class="p-0"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item href="#"> ... </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert
                  :show="alertADismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="alertADismissCountDown = 0"
                  @dismiss-count-down="alertACountDownChanged"
                >
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress
                    variant="warning"
                    :max="alertADismissSecs"
                    :value="alertADismissCountDown"
                    height="4px"
                  />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                  <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid
                  id="gridA"
                  ref="gridA"
                  :dataSource="soggettiFullData"
                  :allowSorting="true"
                  :sortSettings="gridA.sortOptions"
                  :toolbarClick="gridAClickHandler"
                  :toolbar="gridA.toolbarOptions"
                  :height="gridA.height"
                  :allowFiltering="true"
                  :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions"
                  :actionBegin="gridAactionBegin"
                  :actionComplete="gridAactionComplete"
                  locale='it-IT'
                >
                  <e-columns>
                    <e-column
                      field="id"
                      headerText="ID"
                      :isPrimaryKey="true"
                      width="60"
                    ></e-column>
                    <e-column
                      field="denominazione"
                      headerText="Denominazione"
                      width="100"
                    ></e-column>
                    <e-column
                      field="codiceFiscale"
                      headerText="Codice Fiscale"
                      width="100"
                    ></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioSoggettoPersonaFisica ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA"
      ref="dialogA"
      :header="dialogA.header"
      :buttons="dialogA.buttons"
      :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon"
      :close="dialogAClose"
      :open="dialogAOpen"
      :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings"
      :isModal="dialogA.isModal"
      v-on:submit.prevent="noop"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Anagrafica" @click="tabClicked('dialogATab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input: anagrafica -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Anagrafici</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo: soggettiActiveData.id  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox
                        id="id"
                        v-model="soggettiActiveData.id"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="id"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>



                    <!-- Input di tipo testo: soggettiActiveData.nome  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="nome" class="h5">Nome</label>
                      <ejs-textbox
                        id="nome"
                        v-model="soggettiActiveData.nome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.cognome  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="cognome" class="h5">Cognome</label>
                      <ejs-textbox
                        id="cognome"
                        v-model="soggettiActiveData.cognome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Cognome"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.titoloComunicazioni  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="titoloComunicazioni" class="h5"
                        >Titolo per le Comunicazioni</label
                      >
                      <ejs-dropdownlist
                        id="titoloComunicazioni"
                        v-model="soggettiActiveData.titoloComunicazioni"
                        :dataSource="soggettiTitoloComunicazioniList"
                        :fields="soggettiTitoloComunicazioniFields"
                        :allowFiltering="true"
                        placeholder="Titolo Comunicazioni"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.inArte  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="inArte" class="h5">In Arte</label>
                      <ejs-textbox
                        id="inArte"
                        v-model="soggettiActiveData.inArte"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="inArte"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.ragioneSociale  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="ragioneSociale" class="h5"
                        >Ragione Sociale</label
                      >
                      <ejs-textbox
                        id="ragioneSociale"
                        v-model="soggettiActiveData.ragioneSociale"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ragione Sociale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>



                    <!-- Input di tipo testo: soggettiActiveData.codiceFiscale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codiceFiscale" class="h5"
                        >Codice Fiscale</label
                      >
                      <ejs-textbox
                        id="codiceFiscale"
                        v-model="soggettiActiveData.codiceFiscale"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Fiscale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.partitaIva  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="partitaIva" class="h5">Partita IVA</label>
                      <ejs-textbox
                        id="partitaIva"
                        v-model="soggettiActiveData.partitaIva"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita Iva"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.regimeFiscale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="regimeFiscale" class="h5"
                        >Regime Fiscale</label
                      >
                      <ejs-dropdownlist
                        id="regimeFiscale"
                        v-model="soggettiActiveData.regimeFiscale"
                        :dataSource="soggettiRegimeFiscaleList"
                        :fields="soggettiRegimeFiscaleFields"
                        :allowFiltering="true"
                        placeholder="Regime Fiscale"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.esenzione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="esenzione" class="h5"
                        >Esenzione</label
                      >
                      <ejs-dropdownlist
                        id="esenzione"
                        v-model="soggettiActiveData.esenzione"
                        :dataSource="soggettiEsenzioneList"
                        :fields="soggettiEsenzioneFields"
                        :allowFiltering="true"
                        placeholder="Esenzione"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.note  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="soggettiActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <!-- Input di tipo masked: soggettiActiveData.telefono1 -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="telefono1" class="h5"
                        >Telefono Principale</label
                      >
                      <ejs-maskedtextbox
                        id="telefono1"
                        v-model="soggettiActiveData.telefono1"
                        mask="000-0000000"
                        placeholder="Numero di telefono"
                        floatLabelType="Never"
                      />
                    </b-col> -->
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            <!-- Card con Elementi Input: Sede Legale -->
              <b-col xl="6" md="12" v-show="showPersonaGiuridica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Sede Legale</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.sedeLegaleIndirizzo  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="sedeLegaleIndirizzo" class="h5"
                        >Indirizzo Sede Legale</label
                      >
                      <ejs-textbox
                        id="sedeLegaleIndirizzo"
                        v-model="soggettiActiveData.sedeLegaleIndirizzo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Via.."
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.sedeLegaleComune  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="sedeLegaleComune" class="h5"
                        >Comune Sede Legale</label
                      >
                      <ejs-textbox
                        id="sedeLegaleComune"
                        v-model="soggettiActiveData.sedeLegaleComune"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Comune"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.sedeLegaleCap  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="sedeLegaleCap" class="h5"
                        >CAP Sede Legale</label
                      >
                      <ejs-textbox
                        id="sedeLegaleCap"
                        v-model="soggettiActiveData.sedeLegaleCap"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="CAP"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.sedeLegaleProvincia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="sedeLegaleProvincia" class="h5"
                        >Provincia Sede Legale</label
                      >
                      <ejs-textbox
                        id="sedeLegaleProvincia"
                        v-model="soggettiActiveData.sedeLegaleProvincia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Provincia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.sedeLegaleStato  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="sedeLegaleStato" class="h5"
                        >Stato Sede Legale</label
                      >
                      <ejs-textbox
                        id="sedeLegaleStato"
                        v-model="soggettiActiveData.sedeLegaleStato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Stato"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: DatiAnagrafici2 -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Anagrafici</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.nazionalita  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="nazionalita" class="h5">Nazionalità</label>
                      <ejs-dropdownlist
                        id="nazionalita"
                        v-model="soggettiActiveData.nazionalita"
                        :dataSource="soggettiNazionalitaList"
                        :fields="soggettiNazionalitaFields"
                        :allowFiltering="true"
                        placeholder="Selezione Nazionalità"
                        showClearButton="true"
                      />
                    </b-col>

                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="cittadinanza" class="h5">Cittadinanza</label>
                      <ejs-textbox
                        id="cittadinanza"
                        v-model="soggettiActiveData.cittadinanza"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Cittadinanza"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>



                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.sesso  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="sesso" class="h5">Sesso</label>
                      <ejs-dropdownlist
                        id="sesso"
                        v-model="soggettiActiveData.sesso"
                        :dataSource="soggettiSessoList"
                        :fields="soggettiSessoFields"
                        :allowFiltering="true"
                        placeholder="Sesso"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.dataNascita -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="dataNascita" class="h5"
                        >Data di Nascita</label
                      >
                      <ejs-datepicker
                        id="dataNascita"
                        v-model="soggettiActiveData.dataNascita"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Nascita"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.nascitaCitta  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="nascitaCitta" class="h5"
                        >Città di Nascita</label
                      >
                      <ejs-textbox
                        id="nascitaCitta"
                        v-model="soggettiActiveData.nascitaCitta"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Città di Nascita"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.nascitaProvincia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="nascitaProvincia" class="h5"
                        >Provincia di Nascita</label
                      >
                      <ejs-textbox
                        id="nascitaProvincia"
                        v-model="soggettiActiveData.nascitaProvincia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Provincia di Nascita"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <!-- Input di tipo testo: soggettiActiveData.nascitaStato  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="nascitaStato" class="h5"
                        >Stato di Nascita</label
                      >
                      <ejs-textbox
                        id="nascitaStato"
                        v-model="soggettiActiveData.nascitaStato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Stato di Nascita"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Residenza -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Residenza</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.residenzaIndirizzo  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="residenzaIndirizzo" class="h5"
                        >Indirizzo di Residenza</label
                      >
                      <ejs-textbox
                        id="residenzaIndirizzo"
                        v-model="soggettiActiveData.residenzaIndirizzo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Via.."
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.residenzaComune  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="residenzaComune" class="h5"
                        >Comune di Residenza</label
                      >
                      <ejs-textbox
                        id="residenzaComune"
                        v-model="soggettiActiveData.residenzaComune"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Comune"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.residenzaCap  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="residenzaCap" class="h5"
                        >CAP di Residenza</label
                      >
                      <ejs-textbox
                        id="residenzaCap"
                        v-model="soggettiActiveData.residenzaCap"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="CAP"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.residenzaProvincia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="residenzaProvincia" class="h5"
                        >Provincia di Residenza</label
                      >
                      <ejs-textbox
                        id="residenzaProvincia"
                        v-model="soggettiActiveData.residenzaProvincia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Provincia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.residenzaStato  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="residenzaStato" class="h5"
                        >Stato di Residenza</label
                      >
                      <ejs-textbox
                        id="residenzaStato"
                        v-model="soggettiActiveData.residenzaStato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Stato"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Domicilio -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Domicilio</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                     <!-- Input di tipo testo: soggettiActiveData.domicilioIndirizzo  -->
                     <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="domicilioIndirizzo" class="h5"
                        >Indirizzo di Domicilio</label
                      >
                      <ejs-textbox
                        id="domicilioIndirizzo"
                        v-model="soggettiActiveData.domicilioIndirizzo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Via.."
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.domicilioComune  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="domicilioComune" class="h5"
                        >Comune di Domicilio</label
                      >
                      <ejs-textbox
                        id="domicilioComune"
                        v-model="soggettiActiveData.domicilioComune"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Comune"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.domicilioCap  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="domicilioCap" class="h5"
                        >CAP di Domicilio</label
                      >
                      <ejs-textbox
                        id="domicilioCap"
                        v-model="soggettiActiveData.domicilioCap"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="CAP"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.domicilioProvincia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="domicilioProvincia" class="h5"
                        >Provincia di Domicilio</label
                      >
                      <ejs-textbox
                        id="domicilioProvincia"
                        v-model="soggettiActiveData.domicilioProvincia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Provincia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.domicilioStato  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="domicilioStato" class="h5"
                        >Stato di Domicilio</label
                      >
                      <ejs-textbox
                        id="domicilioStato"
                        v-model="soggettiActiveData.domicilioStato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Stato"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>







                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Classificazione -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Classificazione</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo checkbox: soggettiActiveData.isArtista -->
                    <b-col xl="4" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="isArtista" class="h5 mr-1">Artista</label>
                        <ejs-checkbox
                          id="isArtista"
                          v-model="soggettiActiveData.isArtista"
                          :checked="soggettiActiveData.isArtista"
                          name="isArtista"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: soggettiActiveData.isTecnico -->
                    <b-col xl="4" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="isTecnico" class="h5 mr-1">Tecnico</label>
                        <ejs-checkbox
                          id="isTecnico"
                          v-model="soggettiActiveData.isTecnico"
                          :checked="soggettiActiveData.isTecnico"
                          name="isTecnico"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: soggettiActiveData.isFornitore -->
                    <b-col xl="4" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="isFornitore" class="h5 mr-1">Fornitore</label>
                        <ejs-checkbox
                          id="isFornitore"
                          v-model="soggettiActiveData.isFornitore"
                          :checked="soggettiActiveData.isFornitore"
                          name="isFornitore"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.ENPALSCategoria  -->
                    <b-col xl="12" md="12" class="mb-2"
                      v-show="showPersonaFisica" >
                      <label for="ENPALSCategoria" class="h5">
                        Tipologia ENPALS</label>
                      <ejs-dropdownlist
                        id="ENPALSCategoria"
                        v-model="soggettiActiveData.ENPALSCategoria"
                        :dataSource="soggettiENPALSCategoriaList"
                        :fields="soggettiENPALSCategoriaFields"
                        :allowFiltering="true"
                        placeholder="Tipologia ENPALS"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.classePrioritaria  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="classePrioritaria" class="h5">
                        Classe Prioritaria</label>
                      <ejs-dropdownlist
                        id="classePrioritaria"
                        v-model="soggettiActiveData.classePrioritaria"
                        :dataSource="soggettiClassePrioritariaList"
                        :fields="soggettiClassePrioritariaFields"
                        :allowFiltering="true"
                        placeholder="Classe Prioritaria"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.tipologiaServizi  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologiaServizi" class="h5">
                        Tipologia Servizi</label>
                      <ejs-textbox
                        id="tipologiaServizi"
                        v-model="soggettiActiveData.tipologiaServizi"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Tipologia Servizi"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.codiceClifor  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codiceClifor" class="h5">
                        Codice Clifor (Contabilità)</label>
                      <ejs-textbox
                        id="codiceClifor"
                        v-model="soggettiActiveData.codiceClifor"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Clifor (Contabilità)"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.tipoContoClifor  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="tipoContoClifor" class="h5"
                        >Tipo Conto Clifor</label
                      >
                      <ejs-dropdownlist
                        id="tipoContoClifor"
                        v-model="soggettiActiveData.tipoContoClifor"
                        :dataSource="soggettiTipoContoCliforList"
                        :fields="soggettiTipoContoCliforFields"
                        :allowFiltering="true"
                        placeholder="Tipo Conto Clifor"
                      />
                    </b-col> -->
                    <!-- Input di tipo testo: soggettiActiveData.caratteristicaServizi  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="caratteristicaServizi" class="h5"
                        >Caratteristica Servizi</label
                      >
                      <ejs-textbox
                        id="caratteristicaServizi"
                        v-model="soggettiActiveData.caratteristicaServizi"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Caratteristica Servizi"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col> -->
                    <!-- Input di tipo testo: soggettiActiveData.identFiscaleEstero  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="identFiscaleEstero" class="h5">
                        Identificativo Fiscale Estero</label>
                      <ejs-textbox
                        id="identFiscaleEstero"
                        v-model="soggettiActiveData.identFiscaleEstero"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Identificativo Fiscale Estero"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codiceISO" class="h5">Codice ISO</label>
                      <ejs-textbox
                        id="codiceISO"
                        v-model="soggettiActiveData.codiceISO"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Iso"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codiceDestinatario" class="h5">Codice destinatario</label>
                      <ejs-textbox
                        id="codiceDestinatario"
                        v-model="soggettiActiveData.codiceDestinatario"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: DocIdentita -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Documento di Identità</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.docIdentitaNumero  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="docIdentitaNumero" class="h5"
                        >Numero Documento di Identità</label
                      >
                      <ejs-textbox
                        id="docIdentitaNumero"
                        v-model="soggettiActiveData.docIdentitaNumero"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Numero Documento di Identità"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.docIdentitaTipologia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="docIdentitaTipologia" class="h5"
                        >Tipologia Documento di identità</label
                      >
                      <ejs-dropdownlist
                        id="docIdentitaTipologia"
                        v-model="soggettiActiveData.docIdentitaTipologia"
                        :dataSource="soggettiDocIdentitaTipologiaList"
                        :fields="soggettiDocIdentitaTipologiaFields"
                        :allowFiltering="true"
                        placeholder="Tipologia Documento di identità"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.docIdentitaDataEmissione -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="docIdentitaDataEmissione" class="h5"
                        >Data di Emissione del Documento</label
                      >
                      <ejs-datepicker
                        id="docIdentitaDataEmissione"
                        v-model="soggettiActiveData.docIdentitaDataEmissione"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Emissione del Documento"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.docIdentitaDataScadenza -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="docIdentitaDataScadenza" class="h5"
                        >Data di Scadenza del Documento</label
                      >
                      <ejs-datepicker
                        id="docIdentitaDataScadenza"
                        v-model="soggettiActiveData.docIdentitaDataScadenza"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Scadenza del Documento"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: passaporto -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Passaporto</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.passaportoNumero  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="passaportoNumero" class="h5"
                        >Numero Passaporto</label
                      >
                      <ejs-textbox
                        id="passaportoNumero"
                        v-model="soggettiActiveData.passaportoNumero"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Numero Passaporto"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.passaportoDataEmissione -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showPersonaFisica" >
                      <label for="passaportoDataEmissione" class="h5"
                        >Data di Emissione del Documento</label
                      >
                      <ejs-datepicker
                        id="passaportoDataEmissione"
                        v-model="soggettiActiveData.passaportoDataEmissione"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Emissione del Documento"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.passaportoDataScadenza -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showPersonaFisica" >
                      <label for="passaportoDataScadenza" class="h5"
                        >Data di Scadenza del Documento</label>
                      <ejs-datepicker
                        id="passaportoDataScadenza"
                        v-model="soggettiActiveData.passaportoDataScadenza"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Scadenza del Documento"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showPersonaFisica" >
                      <label for="passaportoDataRichiestaRinnovo" class="h5"
                        >Data di richiesta rinnovo passaporto</label>
                      <ejs-datepicker
                        id="passaportoDataRichiestaRinnovo"
                        v-model="soggettiActiveData.passaportoDataRichiestaRinnovo"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di richiesta rinnovo passaporto"
                      />
                    </b-col>

                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: PermessoDiSoggiorno -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Permesso di Soggiorno</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.permSoggNumero  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="permSoggNumero" class="h5"
                        >Numero del Permesso di Soggiorno</label
                      >
                      <ejs-textbox
                        id="permSoggNumero"
                        v-model="soggettiActiveData.permSoggNumero"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Numero Permesso di Soggiorno"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.permSoggDataRilascio -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="permSoggDataRilascio" class="h5"
                        >Data di Rilascio del Permesso di Soggiorno</label
                      >
                      <ejs-datepicker
                        id="permSoggDataRilascio"
                        v-model="soggettiActiveData.permSoggDataRilascio"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Rilascio del Documento"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.permSoggLuogoRilascio  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="permSoggLuogoRilascio" class="h5"
                        >Luogo di Rilascio del Permesso di Soggiorno</label
                      >
                      <ejs-textbox
                        id="permSoggLuogoRilascio"
                        v-model="soggettiActiveData.permSoggLuogoRilascio"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Luogo di Rilascio"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.permSoggTipologia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="permSoggTipologia" class="h5"
                        >Tipologia del Permesso di Soggiorno</label
                      >
                      <ejs-dropdownlist
                        id="permSoggTipologia"
                        v-model="soggettiActiveData.permSoggTipologia"
                        :dataSource="soggettiPermSoggTipologiaList"
                        :fields="soggettiPermSoggTipologiaFields"
                        :allowFiltering="true"
                        placeholder="Tipologia di Permesso di Soggiorno"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.permSoggDataScadenza -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="permSoggDataScadenza" class="h5"
                        >Data di Scadenza del Permesso di Soggiorno</label
                      >
                      <ejs-datepicker
                        id="permSoggDataScadenza"
                        v-model="soggettiActiveData.permSoggDataScadenza"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Scadenza del Documento"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.permSoggDataRichRinnovo -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="permSoggDataRichRinnovo" class="h5">
                          Data di Richiesta di Rinnovo del Permesso di Soggiorno
                      </label>
                      <ejs-datepicker
                        id="permSoggDataRichRinnovo"
                        v-model="soggettiActiveData.permSoggDataRichRinnovo"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Scadenza del Documento"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            <!-- Card con Elementi Input: Contatti -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Contatti</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    
                    <!-- Input di tipo testo: soggettiActiveData.legaleRappresentante  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="legaleRappresentante" class="h5"
                        >Rappresentante Legale</label
                      >
                      <ejs-textbox
                        id="legaleRappresentante"
                        v-model="soggettiActiveData.legaleRappresentante"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Rappresentante Legale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.riferimento  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaGiuridica"
                    >
                      <label for="riferimento" class="h5">Riferimento</label>
                      <ejs-textbox
                        id="riferimento"
                        v-model="soggettiActiveData.riferimento"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Riferimento"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.lingua  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="lingua" class="h5">Lingua</label>
                      <ejs-textbox
                        id="lingua"
                        v-model="soggettiActiveData.lingua"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Lingua"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.agenzia  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="agenzia" class="h5"
                        >Agenzia</label
                      >
                      <ejs-textbox
                        id="agenzia"
                        v-model="soggettiActiveData.agenzia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Agenzia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.sitoWeb  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="sitoWeb" class="h5"
                        >Sito Web</label
                      >
                      <ejs-textbox
                        id="sitoWeb"
                        v-model="soggettiActiveData.sitoWeb"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Sito Web"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.pec  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="pec" class="h5"
                        >Pec</label
                      >
                      <ejs-textbox
                        id="pec"
                        v-model="soggettiActiveData.pec"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Pec"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>






                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Comunicazioni -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Comunicazioni</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.tipoComunicazione1  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="tipoComunicazione1" class="h5"
                        >Tipologia di Comunicazione 1</label
                      >
                      <ejs-textbox
                        id="tipoComunicazione1"
                        v-model="soggettiActiveData.tipoComunicazione1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Tipologia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.riferimento1  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="riferimento1" class="h5"
                        >Riferimento 1</label
                      >
                      <ejs-textbox
                        id="riferimento1"
                        v-model="soggettiActiveData.riferimento1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Riferimento"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.telefono1  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="telefono1" class="h5"
                        >Telefono 1</label
                      >
                      <ejs-textbox
                        id="telefono1"
                        v-model="soggettiActiveData.telefono1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="telefono"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.email1  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="email1" class="h5"
                        >Email 1</label
                      >
                      <ejs-textbox
                        id="email1"
                        v-model="soggettiActiveData.email1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="email"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.tipoComunicazione2  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="tipoComunicazione2" class="h5"
                        >Tipologia di Comunicazione 2</label
                      >
                      <ejs-textbox
                        id="tipoComunicazione2"
                        v-model="soggettiActiveData.tipoComunicazione2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Tipologia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.riferimento2  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="riferimento2" class="h5"
                        >Riferimento 2</label
                      >
                      <ejs-textbox
                        id="riferimento2"
                        v-model="soggettiActiveData.riferimento2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Riferimento"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.telefono2  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="telefono2" class="h5"
                        >Telefono 2</label
                      >
                      <ejs-textbox
                        id="telefono2"
                        v-model="soggettiActiveData.telefono2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="telefono"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.email2  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="email2" class="h5"
                        >Email 2</label
                      >
                      <ejs-textbox
                        id="email2"
                        v-model="soggettiActiveData.email2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="email"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.tipoComunicazione3  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="tipoComunicazione3" class="h5"
                        >Tipologia di Comunicazione 3</label
                      >
                      <ejs-textbox
                        id="tipoComunicazione3"
                        v-model="soggettiActiveData.tipoComunicazione3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Tipologia"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.riferimento3  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="riferimento3" class="h5"
                        >Riferimento 3</label
                      >
                      <ejs-textbox
                        id="riferimento3"
                        v-model="soggettiActiveData.riferimento3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Riferimento"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.telefono3  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="telefono3" class="h5"
                        >Telefono 3</label
                      >
                      <ejs-textbox
                        id="telefono3"
                        v-model="soggettiActiveData.telefono3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="telefono"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.email3  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="email3" class="h5"
                        >Email 3</label
                      >
                      <ejs-textbox
                        id="email3"
                        v-model="soggettiActiveData.email3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="email"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>








                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>



            <!-- Card con Elementi Input: Banche -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Banche</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo testo: soggettiActiveData.banca1Nome  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca1Nome" class="h5"
                        >Nome Banca Principale</label
                      >
                      <ejs-textbox
                        id="banca1Nome"
                        v-model="soggettiActiveData.banca1Nome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Banca"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca1Intestazione  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca1Intestazione" class="h5"
                        >Intestazione Banca Principale</label
                      >
                      <ejs-textbox
                        id="banca1Intestazione"
                        v-model="soggettiActiveData.banca1Intestazione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Intestazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca1IBAN  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca1IBAN" class="h5"
                        >IBAN Banca Principale</label
                      >
                      <ejs-textbox
                        id="banca1IBAN"
                        v-model="soggettiActiveData.banca1IBAN"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="IBAN"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca1SWIFT  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca1SWIFT" class="h5"
                        >SWIFT Banca Principale</label
                      >
                      <ejs-textbox
                        id="banca1SWIFT"
                        v-model="soggettiActiveData.banca1SWIFT"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="SWIFT"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca2Nome  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca2Nome" class="h5"
                        >Nome Banca Secondaria</label
                      >
                      <ejs-textbox
                        id="banca2Nome"
                        v-model="soggettiActiveData.banca2Nome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Banca"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca2Intestazione  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca2Intestazione" class="h5"
                        >Intestazione Banca Secondaria</label
                      >
                      <ejs-textbox
                        id="banca2Intestazione"
                        v-model="soggettiActiveData.banca2Intestazione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Intestazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca2IBAN  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca2IBAN" class="h5"
                        >IBAN Banca Secondaria</label
                      >
                      <ejs-textbox
                        id="banca2IBAN"
                        v-model="soggettiActiveData.banca2IBAN"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="IBAN"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.banca2SWIFT  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="banca2SWIFT" class="h5"
                        >SWIFT Banca Secondaria</label
                      >
                      <ejs-textbox
                        id="banca2SWIFT"
                        v-model="soggettiActiveData.banca2SWIFT"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="SWIFT"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                        <label for="bancaPagamento" class="h5"
                          >Banca Predefinita per pagamento</label
                        >
                        <ejs-dropdownlist
                          id="bancaPagamento"
                          v-model="soggettiActiveData.bancaPagamento"
                          :dataSource="bancaList"
                          :fields="bancaFields"
                          :allowFiltering="true"
                          placeholder="Banca Predefinita per il pagamento"
                          showClearButton="true"
                        />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Iscrizioni -->
            <b-col xl="6" md="12" v-show="showPersonaFisica">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Iscrizioni</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo dropdown senza azioni: soggettiActiveData.titoloDiStudio  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="titoloDiStudio" class="h5"
                        >Titolo Di Studio</label
                      >
                      <ejs-dropdownlist
                        id="titoloDiStudio"
                        v-model="soggettiActiveData.titoloDiStudio"
                        :dataSource="soggettititoloDiStudioList"
                        :fields="soggettititoloDiStudioFields"
                        :allowFiltering="true"
                        placeholder="Titolo Di Studio"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.USCLSIscrizione  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="USCLSIscrizione" class="h5"
                        >Iscrizione USCLS</label
                      >
                      <ejs-textbox
                        id="USCLSIscrizione"
                        v-model="soggettiActiveData.USCLSIscrizione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Matricola"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: soggettiActiveData.ENPALSMatricola  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="ENPALSMatricola" class="h5"
                        >Matricola ENPALS</label
                      >
                      <ejs-textbox
                        id="ENPALSMatricola"
                        v-model="soggettiActiveData.ENPALSMatricola"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Matricola"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo data: soggettiActiveData.ENPALSDataIscrizione -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showPersonaFisica"
                    >
                      <label for="ENPALSDataIscrizione" class="h5"
                        >Data di Iscrizione ENPALS</label
                      >
                      <ejs-datepicker
                        id="ENPALSDataIscrizione"
                        v-model="soggettiActiveData.ENPALSDataIscrizione"
                        :format="settings.formatoDatepicker"
                        placeholder="Data di Iscrizione"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Immagine Profilo -->
            <!-- <b-col xl="6" md="12" v-show="showPersonaFisica"> Da ripristinare quando l'immagine soggetto sarà funzionante -->
            <b-col xl="6" md="12" v-show="nonMostrare">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title> Immagine Profilo</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo immagine con azioni: soggettiActiveData.immagineProfilo -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="immagineProfiloSoggetto" class="h5"
                        >Immagine Profilo Soggetto</label
                      >
                      <b-row>
                        <b-col xl="12" md="12" class="pt-1">
                          <b-img
                            :src="soggettiActiveData.immagineProfilo"
                            fluid
                            alt="Responsive image"
                          />
                        </b-col>
                        <b-col xl="12" md="12" class="text-right mt-1">
                          <ejs-button
                            id="cambiaImmagineProfiloButton"
                            cssClass="e-flat"
                            @click.native="dialogBOpenButtonClick()"
                            >Cambia
                          </ejs-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Caratteristiche -->
            <b-col xl="6" md="12" v-show="nonMostrare">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Caratteristiche</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0"
                  >'
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo altezza: soggettiActiveData.altezza -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="altezza" class="h5">Altezza </label>
                      <ejs-numerictextbox
                        id="altezza"
                        v-model="soggettiActiveData.altezza"
                        floatLabelType="Never"
                        cssClass=""
                        format="cm ###.#"
                        placeholder="Altezza"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo peso: soggettiActiveData.peso -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="peso" class="h5">Peso</label>
                      <ejs-numerictextbox
                        id="peso"
                        v-model="soggettiActiveData.peso"
                        floatLabelType="Never"
                        cssClass=""
                        format="kg ###.###"
                        placeholder="Peso"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo rating: soggettiActiveData.ratingEsperienza -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="ratingEsperienza" class="h5"
                        >Rating Esperienza</label
                      >
                      <b-form-rating
                        id="ratingEsperienza"
                        v-model="soggettiActiveData.ratingEsperienza"
                        variant="warning"
                        stars="5"
                        class="mb-2"
                        show-value
                        show-value-max
                        precision="1"
                      />
                    </b-col>

                    <!-- Input di tipo rating: soggettiActiveData.ratingPerformance -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="ratingPerformance" class="h5"
                        >Rating Performance</label
                      >
                      <b-form-rating
                        id="ratingPerformance"
                        v-model="soggettiActiveData.ratingPerformance"
                        variant="warning"
                        stars="5"
                        class="mb-2"
                        show-value
                        show-value-max
                        precision="1"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Nuovi Componenti -->
            <b-col xl="6" md="12" v-show="nonMostrare">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Nuovi Componenti</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0"
                  >'
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo dropdown entità collegata: artistiActiveData.agente -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="agente" class="h5"
                        >Elenco Dropdown entità collegata 2</label
                      >
                      <b-row>
                        <b-col xl="11" md="9">
                          <ejs-dropdownlist
                            id="entitaCollegata2"
                            v-model="soggettiActiveData.agente"
                            :allowFiltering="true"
                            placeholder="Selezione Entità Collegata"
                            showClearButton="true"
                          />
                        </b-col>
                        <b-col xl="1" md="1" class="text-right">
                          <ejs-button
                            icon-css="e-search-icon"
                            cssClass="e-flat"
                            @click.native="dialogHOpenButtonClick()"
                          />
                        </b-col>
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: soggettiActiveData.nome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="nomeMulti" class="h5">Multilinea</label>
                      <ejs-textbox
                        id="nomeMulti"
                        v-model="soggettiActiveData.nome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Multi"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="2"
                      />
                    </b-col>

                    <!-- Input di tipo multilista: soggettiActiveData.multiListaA -->
                    <!-- <b-col xl="12" md="12" class="mb-2"> -->
                    <!--   <label for="multiListaA" class="h5" -->
                    <!--     >MultiSelect con limiti</label -->
                    <!--   > -->
                    <!--   <ejs-multiselect -->
                    <!--     id="multiListaA" -->
                    <!--     ref="multiListaA" -->
                    <!--     v-model="soggettiActiveData.multiListaA" -->
                    <!--     :dataSource="soggettiMultilistaAList" -->
                    <!--     :maximumSelectionLength="3" -->
                    <!--     mode="CheckBox" -->
                    <!--     :showDropDownIcon="true" -->
                    <!--     :fields="soggettiMultilistaAFields" -->
                    <!--     placeholder="MultilistaA" -->
                    <!--   /> -->
                    <!-- </b-col> -->

                    <!-- Input di tipo calendar multidate:  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calendarMultidate" class="h5"
                        >Calendar Multidate</label
                      >
                      <!-- <ejs-calendar :values="calendarDate" :isMultiSelection="true"></ejs-calendar> -->
                      <ejs-calendar :isMultiSelection="true"></ejs-calendar>
                    </b-col>

                    <!-- Input di tipo RichTextEditor:  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="richText" class="h5">Rich Text Editor</label>
                      <ejs-richtexteditor :toolbarSettings="RTFtoolbarSettings">
                        <p>
                          The rich text editor component is WYSIWYG ("what you
                          see is what you get") editor that provides the best
                          user experience to create and update the content.
                          Users can format their content using standard toolbar
                          commands.
                        </p>
                        <p><b>Key features:</b></p>
                        <ul>
                          <li>
                            <p>Provides IFRAME and DIV modes</p>
                          </li>
                          <li>
                            <p>Capable of handling markdown editing.</p>
                          </li>
                          <li>
                            <p>
                              Contains a modular library to load the necessary
                              functionality on demand.
                            </p>
                          </li>
                          <li>
                            <p>Provides a fully customizable toolbar.</p>
                          </li>
                          <li>
                            <p>
                              Provides HTML view to edit the source directly for
                              developers.
                            </p>
                          </li>
                          <li>
                            <p>Supports third-party library integration.</p>
                          </li>
                          <li>
                            <p>
                              Allows preview of modified content before saving
                              it.
                            </p>
                          </li>
                          <li>
                            <p>
                              Handles images, hyperlinks, video, hyperlinks,
                              uploads, etc.
                            </p>
                          </li>
                          <li>
                            <p>Contains undo/redo manager.</p>
                          </li>
                          <li>
                            <p>Creates bulleted and numbered lists.</p>
                          </li>
                        </ul>
                      </ejs-richtexteditor>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="Documenti Allegati" v-if="nonMostrare" @click="tabClicked('dialogATab02')">
          <b-row class="match-height">
            <!-- Card Grid View: gridDocumentiAllegati -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Elenco Documenti Allegati</b-card-title>
                    <b-card-text class="mb-0"> </b-card-text>
                  </div>
                  <!-- dropdown menù laterale dx -->
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Timer Alert -->
                    <b-col xl="6" md="12">
                      <b-alert
                        :show="alertADismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="alertADismissCountDown = 0"
                        @dismiss-count-down="alertACountDownChanged"
                      >
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress
                          variant="warning"
                          :max="alertADismissSecs"
                          :value="alertADismissCountDown"
                          height="4px"
                        />
                      </b-alert>
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid
                        id="gridB"
                        ref="gridB"
                        :dataSource="docSoggettoFullData"
                        :allowSorting="true"
                        :toolbarClick="gridBClickHandler"
                        :toolbar="gridB.toolbarOptions"
                        :height="gridB.height"
                        :allowFiltering="true"
                        :filterSettings="gridB.filterOptions"
                        :editSettings="gridB.editOptions"
                        :actionBegin="gridBactionBegin"
                        :actionComplete="gridBactionComplete"
                      >
                        <e-columns>
                          <e-column
                            field="id"
                            headerText="ID"
                            :isPrimaryKey="true"
                            width="60"
                          ></e-column>
                          <e-column
                            field="tipologia"
                            headerText="Tipologia"
                            width="200"
                          ></e-column>
                          <e-column
                            field="scadenza"
                            headerText="Scadenza"
                            width="200"
                            :format="settings.formatoData"
                            type="date"
                          ></e-column>
                          <e-column
                            field="note"
                            headerText="Note"
                            width="200"
                          ></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogB: dialogImgProfiloSoggetto ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogB"
      ref="dialogB"
      :header="dialogB.header"
      :buttons="dialogB.buttons"
      :visible="dialogB.visible"
      :showCloseIcon="dialogB.showCloseIcon"
      :close="dialogBClose"
      :open="dialogBOpen"
      :zIndex="dialogB.zIndex"
      :animationSettings="dialogB.animationSettings"
      :isModal="dialogB.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogB" v-model="dialogB.tabAdialogBIndex">
        <b-tab
          title="Sostituzione Immagine"
          @click="tabClicked('dialogBTab01')"
        >
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Informazioni nuova immagine</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo generico: imgSoggettiActiveData.fileImmagine  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="fileImmagine" class="h5">Immagine attuale</label>
                      <ejs-textbox id="fileImmagine" v-model="imgSoggettiActiveData.fileImmagine" floatLabelType="Never"
                        cssClass="" placeholder="Immagine attuale" showClearButton="true" type="text"
                        autocomplete="false" />
                    </b-col> -->

                    <!-- Input di tipo file upload -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="imagePreview" class="h5"
                        >Sostituzione Immagine</label
                      >
                      <ejs-uploader
                        id="imagePreview"
                        ref="uploadObj"
                        name="UploadFiles"
                        :async-settings="dialogBFileUpload.path"
                        :allowed-extensions="dialogBFileUpload.extensions"
                        :removing="addJWTHeaders"
                        :auto-upload="true"
                        :uploading="dialogBonFileUpload"
                        :success="dialogBafterUpload"
                        :drop-area="dialogBFileUpload.dropElement"
                        :buttons="dialogBFileUpload.buttons"
                      />
                    </b-col>

                    <!-- Input di tipo testo generico: imgSoggettiActiveData.commento -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="commentiImmagine" class="h5">Commenti</label>
                      <ejs-textbox
                        id="commentiImmagine"
                        v-model="imgSoggettiActiveData.commento"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Commenti"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con immagine fissa stile input -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Immagine</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo immagine -->
                    <b-col xl="12" md="12" class="mb-2">
                      <b-img
                        :src="imgSoggettiActiveData.fileImmagine"
                        fluid
                        alt="Responsive image"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogD: dialogNuovoDocSoggetto ------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogD"
      ref="dialogD"
      :header="dialogD.header"
      :buttons="dialogD.buttons"
      :visible="dialogD.visible"
      :showCloseIcon="dialogD.showCloseIcon"
      :close="dialogDClose"
      :open="dialogDOpen"
      :zIndex="dialogD.zIndex"
      :animationSettings="dialogD.animationSettings"
      :isModal="dialogD.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogD" v-model="dialogD.tabAdialogDIndex">
        <b-tab title="Inserimento File" @click="tabClicked('dialogDTab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Informazioni File</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo generico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <!-- note da aggiungere? -->
                      <label for="tipologia" class="h5"
                        >Tipologia Documento</label
                      >
                      <ejs-textbox
                        id="tipologia"
                        v-model="docSoggettoActiveData.tipologia"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo generico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="docSoggettoActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="scadenza" class="h5">Scadenza</label>
                      <ejs-datepicker
                        id="scadenza"
                        v-model="docSoggettoActiveData.scadenza"
                        :format="settings.formatoDatepicker"
                      />
                    </b-col>

                    <!-- Timer Alert -->
                    <b-col xl="6" md="12">
                      <b-alert
                        :show="alertADismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="alertADismissCountDown = 0"
                        @dismiss-count-down="alertACountDownChanged"
                      >
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress
                          variant="warning"
                          :max="alertADismissSecs"
                          :value="alertADismissCountDown"
                          height="4px"
                        />
                      </b-alert>
                    </b-col>

                    <!-- grid dei file associati ad un documento -->
                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid
                        id="gridC"
                        ref="gridC"
                        :dataSource="fileDocumentoFullData"
                        :allowSorting="true"
                        :toolbarClick="gridCClickHandler"
                        :toolbar="gridC.toolbarOptions"
                        :height="gridC.height"
                        :allowFiltering="true"
                        :filterSettings="gridC.filterOptions"
                        :editSettings="gridC.editOptions"
                        :actionBegin="gridCactionBegin"
                        :actionComplete="gridCactionComplete"
                      >
                        <e-columns>
                          <e-column
                            field="id"
                            headerText="ID"
                            :isPrimaryKey="true"
                            width="60"
                          ></e-column>
                          <e-column
                            field="etichetta"
                            headerText="Etichetta"
                            width="100"
                          ></e-column>
                          <e-column
                            field="fileDocumento"
                            headerText="Nome File"
                            width="100"
                          ></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogH: dialogElencoEntitaCollegate (non usato, tenuto come template per il futuro se servisse----------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogH"
      ref="dialogH"
      :header="dialogH.header"
      :buttons="dialogH.buttons"
      :visible="dialogH.visible"
      :showCloseIcon="dialogH.showCloseIcon"
      :close="dialogHClose"
      :open="dialogHOpen"
      :zIndex="dialogH.zIndex"
      :animationSettings="dialogH.animationSettings"
      :height="dialogH.height"
      :width="dialogH.width"
      :isModal="dialogH.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogH" v-model="dialogH.tabAdialogHIndex">
        <b-tab
          title="Elenco Entità Collegate"
          @click="tabClicked('dialogHTab01')"
        >
          <b-row class="match-height">
            <!-- Card Grid View: GridElencoSoggetti -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title
                      >Elenco Soggetti Anagrafica Unica</b-card-title
                    >
                    <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
                  </div>
                  <!-- dropdown menù laterale dx -->
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Timer Alert -->
                    <!-- <b-col xl="6" md="12">
                      <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                        @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown"
                          height="4px" />
                      </b-alert>
                    </b-col> -->

                    <b-col xl="12" md="12" class="pt-1">
                      <!-- <ejs-grid id="gridA" ref="gridA" :dataSource="soggettiFullData" :allowSorting="true"
                        :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                        :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                        :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30"></e-column>
                          <e-column field="cognome" headerText="Cognome" width="60"></e-column>
                          <e-column field="nome" headerText="Nome" width="60"></e-column>
                          <e-column field="ragioneSociale" headerText="Ragione Sociale" width="60"></e-column>
                          <e-column field="nazionalita" headerText="Nazionalita" editType='dropdownedit'
                            :edit='nazParams' width="60"></e-column>
                        </e-columns>
                      </ejs-grid> -->
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogI: dialogNuovoFileAllegato ------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogI"
      ref="dialogI"
      :header="dialogI.header"
      :buttons="dialogI.buttons"
      :visible="dialogI.visible"
      :showCloseIcon="dialogI.showCloseIcon"
      :close="dialogIClose"
      :open="dialogIOpen"
      :zIndex="dialogI.zIndex"
      :animationSettings="dialogI.animationSettings"
      :height="dialogI.height"
      :width="dialogI.width"
      :isModal="dialogI.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogI" v-model="dialogI.tabAdialogIIndex">
        <b-tab title="Nuovo File allegato" @click="tabClicked('dialogITab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title
                      >Informazioni nuovo file allegato</b-card-title
                    >
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="etichettaAllegato" class="h5"
                        >Etichetta allegato</label
                      >
                      <ejs-textbox
                        id="etichettaAllegato"
                        ref="etichettaAllegato"
                        v-model="fileDocumentoActiveData.etichetta"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome file"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo file upload -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="fileDocumento" class="h5"
                        >File allegato da caricare</label
                      >
                      <ejs-uploader
                        id="fileDocumento"
                        ref="fileDocumento"
                        name="fileDocumento"
                        :async-settings="dialogIFileUpload.path"
                        :allowed-extensions="dialogIFileUpload.extensions"
                        :removing="addJWTHeaders"
                        :auto-upload="true"
                        :uploading="dialogIonFileUpload"
                        :success="dialogIafterUpload"
                        :drop-area="dialogIFileUpload.dropElement"
                        :buttons="dialogIFileUpload.buttons"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <ejs-dialog
      id="dialogJ"
      ref="dialogJ"
      :header="dialogJ.header"
      :buttons="dialogJ.buttons"
      :visible="dialogJ.visible"
      :showCloseIcon="dialogJ.showCloseIcon"
      :close="dialogJClose"
      :open="dialogJOpen"
      :zIndex="dialogJ.zIndex"
      :animationSettings="dialogJ.animationSettings"
      :height="dialogJ.height"
      :width="dialogJ.width"
      :isModal="dialogJ.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogJ" v-model="dialogJ.tabAdialogJIndex">
        <b-tab title="Nuovo File allegato" @click="tabClicked('dialogJTab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Modifica etichetta allegato</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <b-col xl="12" md="12" class="mb-2">
                        <label for="etichettaAllegato" class="h5"
                          >Etichetta allegato</label
                        >
                        <ejs-textbox
                          id="etichettaAllegato"
                          ref="etichettaAllegato"
                          v-model="fileDocumentoActiveData.etichetta"
                          floatLabelType="Never"
                          cssClass=""
                          placeholder="Nome file"
                          showClearButton="true"
                          type="text"
                          autocomplete="false"
                        />
                      </b-col>
                      <label for="fileActions" class="h5"
                        >Azioni sul File</label
                      >
                      <b-row>
                        <b-col xl="12" md="12" class="text-left mb-1">
                          <ejs-button
                            id="fileDownload"
                            cssClass="e-flat"
                            @click.native="dialogJFileDownload()"
                          >
                            Scarica il File
                          </ejs-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  EmbedPlugin,
  TablePlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormCheckboxPlugin,
  FormSelectPlugin,
  CarouselPlugin,
  FormRatingPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import { enableRipple, loadCldr, L10n, setCulture } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
  CalendarPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  SliderPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
    DropDownListPlugin,
    MultiSelectPlugin,
    ListBoxPlugin,
    CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import {
  RichTextEditorPlugin,
  Link,
  Image,
  HtmlEditor,
  QuickToolbar,
  Toolbar as RTToolbar,
} from "@syncfusion/ej2-vue-richtexteditor"; // rinominato Toolbar RTToolbar incomp con Word
import { SpreadsheetPlugin } from "@syncfusion/ej2-vue-spreadsheet";
import {
  SchedulePlugin,
} from "@syncfusion/ej2-vue-schedule";
import {
  DocumentEditorContainerPlugin,
} from "@syncfusion/ej2-vue-documenteditor";
import {
  PdfViewerPlugin,
  Toolbar as PDFToolbar,
} from "@syncfusion/ej2-vue-pdfviewer"; // rinominato Toolbar PDFToolbar incomp con Word
import { KanbanPlugin } from "@syncfusion/ej2-vue-kanban";
import { GanttPlugin, Edit, Filter, Sort } from "@syncfusion/ej2-vue-gantt";
import { DiagramPlugin } from "@syncfusion/ej2-vue-diagrams";
import {
  MapsPlugin,
} from "@syncfusion/ej2-vue-maps";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

L10n.load({
  'it-IT': {
    'grid': {
      'ConfirmDelete': 'Sei sicuro di cancellare? Clicca OK per confermare la cancellazione, CANCEL per annullare'
    },
    'calendar': { today: 'oggi' } // per cambiare la lingua nei calendar e data occorre qualche passaggio in più (https://ej2.syncfusion.com/vue/documentation/calendar/globalization)
  }
});

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(EmbedPlugin);
Vue.use(TablePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormSelectPlugin);
Vue.use(CarouselPlugin);
Vue.use(FormRatingPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(SliderPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(RichTextEditorPlugin);
Vue.use(SpreadsheetPlugin);
Vue.use(SchedulePlugin);
Vue.use(DocumentEditorContainerPlugin);
Vue.use(PdfViewerPlugin);
Vue.use(KanbanPlugin);
Vue.use(GanttPlugin);
Vue.use(DiagramPlugin);
Vue.use(MapsPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
Vue.use(ListBoxPlugin);
Vue.use(CalendarPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apiSoggettiUrl = "/demo/api/soggetto";
const apiContoUrl = "/demo/api/contobancario";
const apiDocSoggettoUrl = "/demo/api/documento";
const apiFileDocumentoUrl = "/demo/api/filedocumento";
const apiDocumentiUrl = "demo/api/documento";
const apiImgSoggettiUrl = "/demo/api/imgsoggetto"; // da implementare correttamente (collegare a id soggetto)

export default Vue.extend({
  components: {},
  data() {
    return {
      // current logged user
      currentUser: "",
      // spinner
      loading: false,
      // tmp
      showPersonaGiuridica: false,
      showPersonaFisica: false,
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        formatoOra: "HH:mm",
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      // soggetti
      soggettiFullData: [], // elenco completo dati soggetti
      soggettiActiveId: 0, // Id soggetto attivo (0 se nuovo)
      soggettiActiveData: {}, // dati completi dell soggetto attivo
      soggettiSavedData: {}, // dati completi dell soggetto attivo
      soggettiDefaultData: {}, // dati completi di default per nuovi soggetti
      soggettiNazionalitaList: [], // elenco delle nazionalità che un soggetto può assumere (from backend)
      soggettiNazionalitaFields: { text: "naz", value: "id" }, // specifica i campi da estrarre per popolare la lista della nazionalità
      soggettiMultilistaAList: [
        // elenco di prova per validare il componente multilista
        { label: "Amministrativo", id: "amministrativo" },
        { label: "Artistico", id: "artistico" },
        { label: "Artistico Lirico", id: "artisticoLirico" },
        { label: "Professore di orchestra", id: "tecnico" },
        { label: "Tecnico", id: "tecnico" },
      ],
      bancaFields: { text: "label", value: "id" }, // specifica i campi da estrarre per popolare la multilistaA
      bancaList: [],
      soggettiMultilistaAFields: { text: "label", value: "id" }, // specifica i campi da estrarre per popolare la multilistaA
      soggettiXXXList: [
        // elenco di xxx
        { label: "Label1", val: "value1" },
      ],
      soggettiTipoContoCliforFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiTipoContoCliforList: [
        // elenco di xxx
        { label: "Label1", val: "value1" },
      ],
      soggettiTipologiaServiziFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiTipologiaServiziList: [
        // elenco di xxx
        { label: "Label1", val: "value1" },
      ],
      soggettiClassePrioritariaFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiClassePrioritariaList: [
        // elenco di xxx
        { label: "Alta", val: "Alta" },
        { label: "Media", val: "Media" },
        { label: "Bassa", val: "Bassa" },
      ],
      soggettiRegimeFiscaleFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiRegimeFiscaleList: [
        { label: "Non Specificato", val: "nonSpecificato" },
        { label: "Italiano Ordinario", val: "ordinario" },
        { label: "Italiano Forfettario", val: "forfettario" },
        { label: "Italiano Occasionale", val: "occasionale" },
        { label: "Straniero", val: "straniero" },
      ],
      soggettiEsenzioneFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiEsenzioneList: [
        // elenco di xxx
        { label: "A1", val: "A1" },
        { label: "Altro", val: "altro" },
        { label: "Nessuna", val: "nessuna" },
      ],
      soggettiCittadinanzaFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiCittadinanzaList: [
        // elenco di xxx
        { label: "Label1", val: "value1" },
      ],
      soggettititoloDiStudioFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettititoloDiStudioList: [
        // elenco di xxx
        { label: "DIPL. ISTR. SECOND. SUP. CHE PERMETTE L'ACCESSO ALL'UNIVERSITA'", val: "DIPL. ISTR. SECOND. SUP. CHE PERMETTE L'ACCESSO ALL'UNIVERSITA'" },
        { label: "DIPLOMA DI LAUREA", val: "DIPLOMA DI LAUREA" },
        { label: "DIPLOMA DI SPECIALIZZAZIONE", val: "DIPLOMA DI SPECIALIZZAZIONE" },
        { label: "DIPLOMA TERZIARIO EXTRA-UNIVERSITARIO", val: "DIPLOMA TERZIARIO EXTRA-UNIVERSITARIO" },
        { label: "DIPLOMA UNIVERSITARIO", val: "DIPLOMA UNIVERSITARIO" },
        { label: "LAUREA - Vecchio o nuovo ordinamento", val: "LAUREA - Vecchio o nuovo ordinamento" },
        { label: "LAUREA DI PRIMO LIVELLO", val: "LAUREA DI PRIMO LIVELLO" },
        { label: "LAUREA SPECIALISTICA", val: "LAUREA SPECIALISTICA" },
        { label: "LAUREA SPECIALISTICA A CICLO UNICO", val: "LAUREA SPECIALISTICA A CICLO UNICO" },
        { label: "LICENZA ELEMENTARE", val: "LICENZA ELEMENTARE" },
        { label: "LICENZA MEDIA", val: "LICENZA MEDIA" },
        { label: "MASTER UNIVERSITARIO DI PRIMO LIVELLO", val: "MASTER UNIVERSITARIO DI PRIMO LIVELLO" },
        { label: "MASTER UNIVERSITARIO DI SECONDO LIVELLO", val: "MASTER UNIVERSITARIO DI SECONDO LIVELLO" },
        { label: "NESSUN TITOLO DI STUDIO", val: "NESSUN TITOLO DI STUDIO" },
        { label: "TIT. ISTR. SECOND. SUP. (SCOL. ED EXTRA-SCOL.) CHE NON PERMETTE L'ACCESSO ALL'UNIVERSITA'", val: "TIT. ISTR. SECOND. SUP. (SCOL. ED EXTRA-SCOL.) CHE NON PERMETTE L'ACCESSO ALL'UNIVERSITA'" },
        { label: "TITOLO DI DOTTORE DI RICERCA", val: "TITOLO DI DOTTORE DI RICERCA" },
        { label: "TITOLO DI STUDIO POST-LAUREA", val: "TITOLO DI STUDIO POST-LAUREA" },
      ],
      soggettiPermSoggTipologiaFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiPermSoggTipologiaList: [
        // elenco di xxx
        { label: "Studio", val: "studente" },
        { label: "Lavoro", val: "lavoratore" },
        { label: "Lavoro Autonomo", val: "lavoroAutonomo" },
        { label: "Attesa Occupazione", val: "attesaOccupazione" },
        { label: "Motivi Familiari", val: "motiviFamiliari" },
        { label: "Minori", val: "minori" },
        { label: "Cure Mediche", val: "cureMediche" },
        { label: "Soggiornante di lungo periodo - UE", val: "soggiornanteLungoPeriodo" },
      ],
      soggettiDocIdentitaTipologiaFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiDocIdentitaTipologiaList: [
        // elenco di xxx
        { label: "Carta d'Identità", val: "cartaIdentita" },
      ],
      soggettiENPALSCategoriaFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiENPALSCategoriaList: [
        { label: "Tab C - Lavoratori iscritti dopo il 31/12/95", val: "tabC" },
        {
          label: "Tab D - Autonomi già iscritti al 31/12/95 Ex 1° gruppo",
          val: "tabD",
        },
        {
          label: "Tab G - Dipendenti già iscritti al 31/12/95 Ex 2° gruppo",
          val: "tabG",
        },
        {
          label:
            "Tab R - Ballerini e Tersicorei, coreografi e assistenti coreografi",
          val: "tabR",
        },
        { label: "Sconosciuta", val: "sconosciuta" },
      ],
      soggettiSessoFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiSessoList: [
        // elenco di xxx
        { label: "M", val: "M" },
        { label: "F", val: "F" },
      ],
      soggettiTitoloComunicazioniFields: { text: "label", value: "val" },
      soggettiTitoloComunicazioniList: [
        // elenco di xxx
        { label: "Il Maestro", val: "Il Maestro" },
        { label: "Il Dott.", val: "Il Dott." },
        { label: "La Dott.ssa", val: "La Dott.ssa" },
        { label: "Il Prof.", val: "Il Prof." },
        { label: "La Prof.ssa", val: "La Prof.ssa" },
        { label: "Il Sig.", val: "Il Sig." },
        { label: "La Sig.ra", val: "La Sig.ra" },
        { label: "L'Ing.", val: "L'Ing." },
        { label:  "L'Arch.", val: "L'Arch." },
        { label: "Il Geom.", val: "Il Geom." },
      ],
      soggettiXXXFields: { text: "label", value: "val" }, // specifica i campi da estrarre per popolare XXX
      soggettiXXXList: [
        // elenco di xxx
        { label: "Label1", val: "value1" },
      ],
      // docSoggetto
      docSoggettoFullData: [], // elenco completo dati documenti allegati soggetti
      docSoggettoActiveId: 0, // Id documento allegato soggetti attivo (0 se nuovo)
      docSoggettoActiveData: {}, // dati completi del documento allegato soggetti attivo
      docSoggettoDefaultData: {}, // dati completi di default per nuovi documenti allegato soggetti
      // fileDocumento
      fileDocumentoFullData: [], // elenco completo dei file associati ad un DocumentoSoggetto
      fileDocumentoActiveId: 0, // Id file documento attivo (0 se nuovo)
      fileDocumentoActiveData: {}, // dati completi del file attualmente visualizzato
      fileDocumentoDefaultData: {},
      // imgSoggetti
      imgSoggettiFullData: [], // elenco completo immagini soggetti
      imgSoggettiActiveId: 0, // Id immagine soggetti attiva (0 se nuova)
      imgSoggettiActiveData: {}, // dati completi della immagine soggetti attiva
      imgSoggettiDefaultData: {}, // dati completi di default per nuove immagini soggetti

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per dialogB
      dialogB: {
        header: "Sostituzione immagine profilo",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogBOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogBCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogBIndex: 0,
        isModal: false,
      },
      // per dialogD
      dialogD: {
        header: "Nuovo Documento Soggetto",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogDOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogDCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogDIndex: 0,
        isModal: false,
      },
      // per dialogH
      dialogH: {
        header: "Elenco Entità Collegate",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogHOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogHCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogHIndex: 0,
        height: "90%",
        width: "90%",
        isModal: true,
      },
      // per dialogI
      dialogI: {
        header: "Nuovo file allegato",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogIOk,
            buttonModel: { content: "OKKK", isPrimary: true },
          },
          { click: this.dialogICancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 },
        zIndex: 1070,
        tabAdialogIIndex: 0,
        height: "80%",
        width: "80%",
        isModal: true,
      },
      // per dialogJ
      dialogJ: {
        header: "Modifica file allegato",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogJOk,
            buttonModel: { content: "Salva", isPrimary: true },
          },
          { click: this.dialogJCancel, buttonModel: { content: "Annulla" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 },
        zIndex: 1070,
        tabAdialogJIndex: 0,
        height: "80%",
        width: "80%",
        isModal: true,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
          showDeleteConfirmDialog: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuova Persona Fisica",
            tooltipText: "Inserisci nuovo soggetto",
            prefixIcon: "e-plus",
            id: "newPF",
          },
          {
            text: "Nuova Persona Giuridica",
            tooltipText: "Inserisci nuovo soggetto",
            prefixIcon: "e-plus",
            id: "newPG",
          },
          {
            text: "Modifica Soggetto",
            tooltipText: "Modifica soggetto",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella Soggetto",
            tooltipText: "Cancella soggetto",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "id", direction: "Ascending" }] },
      },
      // per gridB
      gridBFlag: false,
      gridB: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuovo documento",
            prefixIcon: "e-plus",
            id: "newDoc",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica documento",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Elimina",
            tooltipText: "Cancella documento",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Scarica",
            tooltipText: "Scarica documento",
            prefixIcon: "e-save",
            id: "download",
          },
          "Search",
        ],
      },
      // per gridC di gestione fileDocumento
      gridC: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuovo file",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica file",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Elimina",
            tooltipText: "Cancella file",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Scarica",
            tooltipText: "Scarica file",
            prefixIcon: "e-save",
            id: "download",
          },
          "Search",
        ],
      },
      //
      // dati per dialogB fileUpload
      dialogBFileUpload: {
        path: {
          saveUrl: apiVueEndPoint + apiImgSoggettiUrl,
          //removeUrl: `${apiVueEndPoint + apiImgSoggettiUrl}/remove`, // ??
        },
        extensions: ".jpg, .png",
        dropElement: ".control-fluid",
        buttons: {
          browse: "Seleziona un file",
        },
      },
      dialogIFileUpload: {
        path: {
          saveUrl: apiVueEndPoint + apiFileDocumentoUrl,
          //removeUrl: `${apiVueEndPoint + apiImgSoggettiUrl}/remove`, //??
        },
        extensions: ".jpg, .png, .pdf",
        dropElement: ".control-fluid",
        buttons: {
          browse: "Seleziona un file",
        },
      },

      // dati provvisori per richTextField
      RTFtoolbarSettings: {
        type: "Expand",
        enableFloating: true,
        items: [
          "Bold",
          "Italic",
          "Underline",
          "StrikeThrough",
          "FontName",
          "FontSize",
          "FontColor",
          "BackgroundColor",
          "LowerCase",
          "UpperCase",
          "|",
          "Formats",
          "Alignments",
          "OrderedList",
          "UnorderedList",
          "Outdent",
          "Indent",
          "|",
          "CreateLink",
          "Image",
          "|",
          "ClearFormat",
          "Print",
          "SourceCode",
          "FullScreen",
          "|",
          "Undo",
          "Redo",
        ],
      },
    };
  },
  created() {
    console.log("Pagina Anagrafica Unica Creata");
    // inizializzazione elenchi dal backend
    // chiamate API
    const uD = JSON.parse(localStorage.getItem('userData'))
    this.currentUser = uD['username']

    // soggettiNazionalità e soggettiRuoli
    console.log("Recupero elenchi dal backend");
    useJwt.get("/api/personalespettacolo/ruoli").then((d) => {
      if (d.status === 200) {
        //cambiare ruoli in qualcosa di generico tipo listeSoggetto
        console.log("Nazionalità");
        this.soggettiNazionalitaList = d.data.nazionalita;
        // soggettiRuoliList
        //this.soggettiRuoliList = d.data.ruoli
      } else {
        this.makeToast(
          "primary",
          "ERRORE",
          "Errore sessione scaduta"
        );
      }
    });

    this.loading = true
    console.log(this.loading)
    // soggettiFullData
    // recupero elenco soggetti dal backend
    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco soggetti dal backend");
      useJwt.get(apiSoggettiUrl).then((d) => {
        if (d.status === 200) {
          // console.log("SOGGETTI");
          // console.log(d.data);
          this.soggettiFullData = d.data;
          this.loading = false
        } else {
          this.makeToast(
            "primary",
            "ERRORE",
            "Errore sessione scaduta"
          );
        }
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
    useJwt.get(apiContoUrl).then((d) => {
      if (d.status === 200) {
        console.log("Conti correnti");
        console.log(d.data);
        d.data.forEach((obj) => {
          this.bancaList.push({'label': obj.nome, 'id': obj.id})
        })
      } else {
        this.makeToast(
          "primary",
          "ERRORE",
          "Errore sessione scaduta"
        );
      }
    });


    // Recupero/definisco i valori di default delle entità utilizzate nel componente


    // soggettiDefaultData ( esplicitato nei pulsanti "Nuovo.." della gridA )
    this.soggettiDefaultData = {};

    // docSoggettoDefaultData
    this.docSoggettoDefaultData = {
      id: 0,
      note: "",
      tipologia: "",
      scadenza: "",
    };

    this.fileDocumentoDefaultData = {
      id: 0,
      etichetta: "",
    };

    // imgSoggettiDefaultData
    this.imgSoggettiDefaultData = {
      id: 0,
      fileImmagine: "https://picsum.photos/1024/400/?image=51",
      commento: "",
    };
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per listBox
    listbox: [CheckBoxSelection],
    // per multiselect
    multiselect: [CheckBoxSelection],
    // per richTextEditor
    richtexteditor: [RTToolbar, Link, Image, QuickToolbar, HtmlEditor],
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance
        .get(url, {
          responseType: "arraybuffer",
          crossdomain: true,
        })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("Soggetto attivo");
      console.log(this.soggettiActiveId);
      this.soggettiSavedData = { ...this.soggettiActiveData };
      this.imgSoggettiActiveData = this.imgSoggettiDefaultData;
      // this.imgSoggettiActiveId = 0
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      console.log(this.soggettiActiveData);
    },
    async dialogAOk() {
      let error = false
      console.log("Cliccato bottone OK di dialogA");
      this.soggettiActiveData['currentUser'] = this.currentUser
      // salvataggio informazioni in remoto
      if (this.soggettiActiveId === 0) {
        // salvataggio in caso di new

        if ((!this.soggettiActiveData.ragioneSociale) && (this.soggettiActiveData.isFornitore)) {
          this.soggettiActiveData.ragioneSociale = this.soggettiActiveData.cognome + ' ' + this.soggettiActiveData.nome
        }
        error = await useJwt
              .post(apiSoggettiUrl, this.soggettiActiveData)
              .then((res) => {
                  //console.log(res.status);
                  this.soggettiActiveId = res.data.id;
                  return this; // restituisci contesto per permettere aggiornamento grid
              })
              .then((context) => {
                  useJwt.get(apiSoggettiUrl).then((res) => {
                      console.log("Aggiornamento gridA con l'aggiunta di un soggetto");
                      context.soggettiFullData = res.data;
                      context.soggettiFullData = [...context.soggettiFullData];
                  });
                  return false
              }).catch(error => {
                  let messaggio = ""
                  if (error.response) {
                      //console.log(error.response.data)
                      let chiavi = Object.keys(error.response.data)
                      // console.log(error.response.data['soggetto'])
                      // console.log(error.response.data['tipologia'])
                      chiavi.forEach((k) => {
                          messaggio += `${k}: ${error.response.data[k]}`
                          messaggio += "\n"
                      })
                      console.log(messaggio)
                      this.makeToast("primary", "ERRORE", messaggio);
                  }
                  return true
              })
          if (!error) {
            this.makeToast("primary", "Creazione", "Creazione soggetto avvenuta con successo");
            this.$refs.dialogA.hide();
          }
      } else {
          // salvataggio in caso di edit
          const editUrl = `${apiSoggettiUrl}/${this.soggettiActiveId}`;
          // riscrivo ragioneSociale solo se il soggetto e' una personaFisica
          if (this.soggettiActiveData.tipoSoggetto === 'PersonaFisica') {
            if ((!this.soggettiActiveData.ragioneSociale) && (this.soggettiActiveData.isFornitore)) {
              this.soggettiActiveData.ragioneSociale = this.soggettiActiveData.cognome + ' ' + this.soggettiActiveData.nome
            }
          }
          error = await useJwt.patch(editUrl, this.soggettiActiveData)
              .then((res) => {
                  console.log(res.status);
                  return this; // restituisci contesto per permettere aggiornamento gridA
              })
              .then((context) => {
                  useJwt.get(apiSoggettiUrl).then((res) => {
                      console.log("Aggiornamento gridA con la modifica di un soggetto");
                      context.soggettiFullData = res.data;
                      context.soggettiFullData = [...context.soggettiFullData];
                  });
                  return false
              }).catch(error => {
                  let messaggio = ""
                  if (error.response) {
                      //console.log(error.response.data)
                      let chiavi = Object.keys(error.response.data)
                      // console.log(error.response.data['soggetto'])
                      // console.log(error.response.data['tipologia'])
                      chiavi.forEach((k) => {
                          messaggio += `${k}: ${error.response.data[k]}`
                          messaggio += "\n"
                      })
                      console.log(messaggio)
                      this.makeToast("primary", "ERRORE", messaggio);
                  }
                  return true
              })
          if (!error) {
            this.makeToast("primary", "Modifica", "Modifica soggetto avvenuta con successo");
            this.$refs.dialogA.hide();
          }
      }
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per dialogB
    dialogBOpenButtonClick() {
      this.imgSoggettiActiveData.fileImmagine =
        this.soggettiActiveData.immagineProfilo;
      this.imgSoggettiActiveData.commento = "";
      this.$refs.dialogB.show(true);
    },
    dialogBOpen(args) {
      console.log("Apertura dialogB");
      // assegnare le informazioni da visualizzare nel dialogB
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogBClose() {
      console.log("Chiusura dialogB");
      // document.getElementById('dialogBOpenButton').style.display = '';
      this.dialogB.tabAdialogBIndex = 0;
    },
    dialogBOk() {
      console.log("Cliccato bottone OK di dialogB");
      // TODO......
      this.$refs.dialogB.hide();
    },
    dialogBCancel() {
      console.log("Cliccato bottone Cancel di dialogB");
      this.$refs.dialogB.hide();
    },
    dialogBonFileUpload(args) {
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
      // add addition data as key-value pair.
      args.customFormData = [{ soggetto_id: this.soggettiActiveId }];
    },
    dialogBafterUpload(args) {
      console.log(args);
      if (args.name === "success") {
        console.log("tutto a posto");
        console.log(args.e.target.response);
        //const imgUrl = args.e.target.response
        const imgUrl = args.e.target.response.replace(/"/g, ""); // rimuovi apici dalla risposta ottenuta dal backend
        this.imgSoggettiActiveData.fileImmagine = imgUrl;
        this.soggettiActiveData.immagineProfilo =
          this.imgSoggettiActiveData.fileImmagine;
        // TODO: reload immagine?
        // TODO: Salvare il soggetto con immagineProfilo aggiornata?? <--------- PER FABIO
        console.log("salvo soggetto con immagine aggiornata"); // aggiunta simo 19/01
        console.log(this.soggettiActiveData.immagineProfilo); // aggiunta simo 19/01
        this.salvaSoggetto(); // aggiunta simo 19/01
        this.$refs.uploadObj.clearAll(); // aggiunta simo 19/01
      }
    },
    // per dialogD
    dialogDOpen(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
      console.log("Apertura dialogD");
      // assegnare le informazioni da visualizzare nel dialogD
      // devo fare una get da apiFileDocumentoUrl per ottenere la lista dei file associati a quel documentoSoggetto

      useJwt
        .get(apiFileDocumentoUrl, { id: this.docSoggettoActiveId })
        .then((d) => {
          console.log("DIALOGD get response");
          console.log(d.data);
          // usare questi dati per popolare la grid del dialogD
          this.fileDocumentoFullData = d.data;
          // trigger refresh della grid
        });
    },
    dialogDClose() {
      console.log("Chiusura dialogD");
      // document.getElementById('dialogDOpenButton').style.display = '';
      this.dialogD.tabAdialogDIndex = 0;
    },
    dialogDOk() {
      // voglio salvare un nuovo documentoSoggetto
      console.log("Cliccato bottone OK di dialogD");

      if (this.docSoggettoActiveId === 0) {
        this.docSoggettoActiveData.soggetto = this.soggettiActiveId; // associo ID soggetto corrente

        console.log("voglio salvare queste info");
        console.log(this.docSoggettoActiveData);
        console.log(
          `id soggetto corrente (a cui associare il documento) ${this.soggettiActiveId}`
        );

        useJwt
          .post(apiDocSoggettoUrl, this.docSoggettoActiveData)
          .then((res) => {
            console.log(res.status);
            console.log(res.data);
            this.docSoggettoActiveId = res.data.id;
            this.docSoggettoActiveData.id = res.data.id;
            this.docSoggettoFullData.push(res.data);
            // refresh grid
            this.docSoggettoFullData = [...this.docSoggettoFullData];
          });
      } else {
        console.log("voglio salvare modifiche con queste info");
        // gestione modifica
        console.log(this.docSoggettoActiveData);
        const editUrl = `${apiDocSoggettoUrl}/${this.docSoggettoActiveId}`;
        useJwt.patch(editUrl, this.docSoggettoActiveData).then((res) => {
          console.log(res.status);
          console.log("INFO SALVATE E RESTITUITE");
          console.log(res.data);

          console.log("Loop su fullData");
          console.log(this.docSoggettoFullData);
          this.docSoggettoFullData.forEach((obj) => {
            if (obj.id === res.data.id) {
              obj.tipologia = res.data.tipologia;
              obj.scadenza = res.data.scadenza;
              obj.note = res.data.note;
            }
          });
          // update grid
          this.docSoggettoFullData = [...this.docSoggettoFullData];
        });
      }
      this.$refs.dialogD.hide();
    },
    dialogDCancel() {
      console.log("Cliccato bottone Cancel di dialogD");
      this.$refs.dialogD.hide();
    },
    // per dialogH
    dialogHOpenButtonClick() {
      //this.$refs.dialogH.show(true)
      this.$refs.dialogH.show();
    },
    dialogHOpen(args) {
      console.log("Apertura dialogH");
      // assegnare le informazioni da visualizzare nel dialogE

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogHClose() {
      console.log("Chiusura dialogH");
      // document.getElementById('dialogEOpenButton').style.display = '';
      this.dialogH.tabAdialogEIndex = 0;
    },
    dialogHOk() {
      console.log("Cliccato bottone OK di dialogH");
      // TODO......
      this.$refs.dialogH.hide();
    },
    dialogHCancel() {
      console.log("Cliccato bottone Cancel di dialogH");
      this.$refs.dialogH.hide();
    },
    // per dialogI
    dialogIOpen(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

      console.log("Apertura dialogI");
      // assegnare le informazioni da visualizzare nel dialogE
    },
    dialogIClose() {
      console.log("Chiusura dialogI");
      // document.getElementById('dialogEOpenButton').style.display = '';
      this.dialogI.tabAdialogEIndex = 0;
    },
    dialogIOk() {
      console.log("Cliccato bottone OK di dialogI");
      // TODO......
      this.$refs.dialogI.hide();
    },
    dialogICancel() {
      console.log("Cliccato bottone Cancel di dialogI");
      this.$refs.dialogI.hide();
    },
    dialogIonFileUpload(args) {
      // da sistemare
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
      // add addition data as key-value pair.
      args.customFormData = [
        { documentosoggetto_id: this.docSoggettoActiveId },
        { etichetta: this.fileDocumentoActiveData.etichetta },
      ];
    },
    dialogIafterUpload(args) {
      console.log(args);
      if (args.name === "success") {
        this.makeToast(
          "primary",
          "Caricamento",
          "Caricamento file eseguito con successo"
        );
        // console.log('tutto a posto')
        // console.log(args.e.target.response)
        const r = JSON.parse(args.e.target.response);
        // refresh grid
        this.fileDocumentoFullData.push(r);
        this.fileDocumentoFullData = [...this.fileDocumentoFullData];

        this.fileDocumentoActiveId = 0;
        this.fileDocumentoActiveData = this.fileDocumentoDefaultData;
        this.$refs.fileDocumento.clearAll();
        // devo chiudere il dialog
        this.$refs.dialogI.hide();
      } else {
        this.makeToast("primary", "Caricamento", "Caricamento file fallito");
      }
    },
    // dialogJ
    dialogJOpen(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

      console.log("Apertura dialogJ");
      // assegnare le informazioni da visualizzare nel dialogE
    },
    dialogJClose() {
      console.log("Chiusura dialogJ");
      this.dialogJ.tabAdialogEIndex = 0;
    },
    dialogJOk() {
      console.log("Cliccato bottone OK di dialogJ");
      // TODO......
      const editUrl = `${apiFileDocumentoUrl}/${this.fileDocumentoActiveId}`;
      useJwt
        .patch(editUrl, { etichetta: this.fileDocumentoActiveData.etichetta })
        .then((res) => {
          console.log(res.data);
          if (res.status === 200) {
            // se tutto OK
            this.makeToast(
              "primary",
              "Successo",
              "Salvataggio etichetta eseguito con successo"
            );
            // sostituisci in grid
            this.fileDocumentoFullData.forEach((obj) => {
              console.log(obj.id === res.data.id);
              if (obj.id === res.data.id) {
                obj.etichetta = res.data.etichetta;
                this.fileDocumentoFullData = [...this.fileDocumentoFullData];
              }
            });
          } else {
            this.makeToast(
              "primary",
              "Attenzione",
              "Salvataggio soggetto non riuscito"
            );
          }
        });
      // salva etichetta
      console.log(this.fileDocumentoActiveData.etichetta);
      this.$refs.dialogJ.hide();
    },
    dialogJCancel() {
      console.log("Cliccato bottone Cancel di dialogJ");
      this.$refs.dialogJ.hide();
    },
    dialogJFileDownload() {
      this.makeToast(
        "info",
        "Azione",
        `Apri il file ${this.fileDocumentoActiveData.nome}`
      );
      // remove URL prefix and suffix from AWS filename
      const nomeFile = this.fileDocumentoActiveData.fileDocumento
        .split("\\")
        .pop()
        .split("/")
        .pop()
        .split("?")[0];
      console.log(`Nome file ${nomeFile}`);
      this.downloadFile(this.fileDocumentoActiveData.fileDocumento, nomeFile);
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "newPF") {
        this.showPersonaFisica = true;
        this.showPersonaGiuridica = false;
        this.dialogA.header = "Nuovo soggetto fisico";
        this.soggettiDefaultData = {
          id: 0,
          tipoSoggetto: "PersonaFisica",
          isArtista: false,
          isTecnico: false,
          isFornitore: false,
          nome: "",
          cognome: "",
          inArte: "",
          ragioneSociale: "",
          legaleRappresentante: "",
          codiceFiscale: "",
          partitaIva: "",
          tipoContoClifor: "",
          tipologiaServizi: "",
          codiceClifor: "",
          caratteristicaServizi: "",
          note: "",
          classePrioritaria: "",
          regimeFiscale: "",
          esenzione: null,
          riferimento: "",
          lingua: "",
          identFiscaleEstero: "",
          codiceISO: "",
          nazionalita: "eu",
          cittadinanza: "",
          titoloDiStudio: "",
          sesso: "",
          docIdentitaNumero: "",
          docIdentitaTipologia: "",
          docIdentitaDataEmissione: "",
          docIdentitaDataScadenza: "",
          passaportoNumero: "",
          passaportoDataEmissione: "",
          passaportoDataScadenza: "",
          permSoggNumero: "",
          permSoggDataRilascio: "",
          permSoggLuogoRilascio: "",
          permSoggTipologia: "",
          permSoggDataScadenza: "",
          permSoggDataRichRinnovo: "",
          sedeLegaleIndirizzo: "",
          sedeLegaleComune: "",
          sedeLegaleCap: "",
          sedeLegaleProvincia: "",
          sedeLegaleStato: "",
          titoloComunicazioni: "",
          nascitaCitta: "",
          nascitaProvincia: "",
          dataNascita: "",
          nascitaStato: "",
          residenzaIndirizzo: "",
          residenzaComune: "",
          residenzaCap: "",
          residenzaProvincia: "",
          residenzaStato: "",
          domicilioIndirizzo: "",
          domicilioComune: "",
          domicilioCap: "",
          domicilioProvincia: "",
          domicilioStato: "",
          USCLSIscrizione: "",
          ENPALSMatricola: "",
          ENPALSDataIscrizione: "",
          ENPALSCategoria: "sconosciuta",
          agenzia: "",
          sitoWeb: "",
          pec: "",
          tipoComunicazione1: "",
          telefono1: "",
          email1: "",
          riferimento1: "",
          tipoComunicazione2: "",
          telefono2: "",
          email2: "",
          riferimento2: "",
          tipoComunicazione3: "",
          telefono3: "",
          email3: "",
          riferimento3: "",
          banca1Nome: "",
          banca1Intestazione: "",
          banca1IBAN: "",
          banca1SWIFT: "",
          banca2Nome: "",
          banca2Intestazione: "",
          banca2IBAN: "",
          banca2SWIFT: "",
          sorgente: "",
          immagineProfilo: "https://picsum.photos/1024/400/?image=51",
          under35: false,
          multiListaA: [],
        };
        this.soggettiActiveData = this.soggettiDefaultData;
        console.log(
          "Premuto pulsante creazione nuovo soggetto fisico da gridA"
        );
        // console.log(this.soggettiActiveData);
        // console.log(this.soggettiDefaultData);
        this.soggettiActiveId = 0;
        this.$refs.dialogA.show(true);
      }
      // pulsante newPG
      else if (args.item.id === "newPG") {
        this.showPersonaFisica = false;
        this.showPersonaGiuridica = true;
        this.dialogA.header = "Nuovo soggetto giuridico";
        this.soggettiDefaultData = {
          id: 0,
          tipoSoggetto: "PersonaGiuridica",
          isArtista: false,
          isTecnico: false,
          isFornitore: false,
          nome: "",
          cognome: "",
          inArte: "",
          ragioneSociale: "",
          legaleRappresentante: "",
          codiceFiscale: "",
          partitaIva: "",
          tipoContoClifor: "",
          tipologiaServizi: "",
          codiceClifor: "",
          caratteristicaServizi: "",
          note: "",
          classePrioritaria: "",
          regimeFiscale: "",
          esenzione: null,
          riferimento: "",
          lingua: "",
          identFiscaleEstero: "",
          codiceISO: "",
          nazionalita: "eu",
          cittadinanza: "",
          titoloDiStudio: "",
          sesso: "",
          docIdentitaNumero: "",
          docIdentitaTipologia: "",
          docIdentitaDataEmissione: "",
          docIdentitaDataScadenza: "",
          passaportoNumero: "",
          passaportoDataEmissione: "",
          passaportoDataScadenza: "",
          permSoggNumero: "",
          permSoggDataRilascio: "",
          permSoggLuogoRilascio: "",
          permSoggTipologia: "",
          permSoggDataScadenza: "",
          permSoggDataRichRinnovo: "",
          sedeLegaleIndirizzo: "",
          sedeLegaleComune: "",
          sedeLegaleCap: "",
          sedeLegaleProvincia: "",
          sedeLegaleStato: "",
          titoloComunicazioni: "",
          nascitaCitta: "",
          nascitaProvincia: "",
          dataNascita: "",
          nascitaStato: "",
          residenzaIndirizzo: "",
          residenzaComune: "",
          residenzaCap: "",
          residenzaProvincia: "",
          residenzaStato: "",
          domicilioIndirizzo: "",
          domicilioComune: "",
          domicilioCap: "",
          domicilioProvincia: "",
          domicilioStato: "",
          USCLSIscrizione: "",
          ENPALSMatricola: "",
          ENPALSDataIscrizione: "",
          ENPALSCategoria: "sconosciuta",
          agenzia: "",
          sitoWeb: "",
          pec: "",
          tipoComunicazione1: "",
          telefono1: "",
          email1: "",
          riferimento1: "",
          tipoComunicazione2: "",
          telefono2: "",
          email2: "",
          riferimento2: "",
          tipoComunicazione3: "",
          telefono3: "",
          email3: "",
          riferimento3: "",
          banca1Nome: "",
          banca1Intestazione: "",
          banca1IBAN: "",
          banca1SWIFT: "",
          banca2Nome: "",
          banca2Intestazione: "",
          banca2IBAN: "",
          banca2SWIFT: "",
          sorgente: "",
          immagineProfilo: "https://picsum.photos/1024/400/?image=51",
          under35: false,
          multiListaA: [],
        };
        this.soggettiActiveData = this.soggettiDefaultData;
        console.log(
          "Premuto pulsante creazione nuovo soggetto giuridico da gridA"
        );
        // console.log(this.soggettiActiveData);
        this.soggettiActiveId = 0;
        this.$refs.dialogA.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica soggetto da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          let found = false;
          this.soggettiActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.soggettiActiveId);
          for (const i in this.soggettiFullData) {
            if (this.soggettiFullData[i].id === this.soggettiActiveId) {
              // console.log("id dell'elenco trovato:")
              // console.log('SOGGETTO CORRENTE')
              // console.log(this.soggettiFullData[i])
              this.soggettiActiveData = { ...this.soggettiFullData[i] };
              // fix nome immagineProfilo AWS (TMP)
              //this.soggettiActiveData.immagineProfilo = "https://drf-coccia.s3.eu-south-1.amazonaws.com/drf-coccia/tmpImage_HB7y2N2.jpg" // aggiunto Simo 19/01
              found = true;
              break;
            }
          }
          console.log("SOGGETTO CORRENTE");
          console.log(this.soggettiActiveData);
          console.log(this.soggettiActiveId);

          // Richiedi documenti associati al soggetto corrente
          const documentiSoggettoUrl = `${process.env.VUE_APP_API_ENDPOINT}/${apiDocumentiUrl}/${this.soggettiActiveId}`;
          useJwt.axiosIns
            .get(documentiSoggettoUrl, { crossdomain: true })
            .then((res) => {
              console.log(res.data["data"]);
              this.docSoggettoFullData = res.data["data"];
            });

          if (found) {
            // Smisto in base a tipoSoggetto
            if (this.soggettiActiveData.tipoSoggetto === "PersonaFisica") {
              // persona fisica
              console.log("Edit persona fisica");
              this.dialogA.header = "Modifica Persona Fisica";
              this.showPersonaFisica = true;
              this.showPersonaGiuridica = false;
              this.$refs.dialogA.show(true);
            } else {
              // persona giuridica
              console.log("Edit persona giuridica");
              this.dialogA.header = "Modifica Persona Giuridica";
              this.showPersonaFisica = false;
              this.showPersonaGiuridica = true;
              this.$refs.dialogA.show(true);
            }
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina scrittura da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          this.$refs.gridA.ej2Instances.deleteRecord();
        } catch (err) {
         console.log(err);
         console.log("Occorre selezionare una riga della tabella");
         this.alertAShow();
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiSoggettiUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio soggetto non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
      if (e.requestType === "delete") {
        try {
          console.log("Premuto pulsante elimina soggetto da gridA");
          const deletedElementId = e.data[0].id;
          const deleteUrl = `${apiSoggettiUrl}/${deletedElementId}`;
          const datiDaInviare = { 'currentUser': this.currentUser }
          useJwt.delete(deleteUrl, {data: datiDaInviare}).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    // per gridC -> lista file allegati a documento
    gridCClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        // se documentoSoggetto non e' ancora stato salvato, fallo ora per poter poi gestire upload
        if (this.docSoggettoActiveId === 0) {
          // documentosoggetto da salvare
          console.log("NOTA: documentosoggetto da salvare");

          this.docSoggettoActiveData.soggetto = this.soggettiActiveId; // associo ID soggetto corrente

          console.log("voglio salvare queste info");
          console.log(this.docSoggettoActiveData);
          console.log(
            `id soggetto corrente (a cui associare il documento) ${this.soggettiActiveId}`
          );

          useJwt
            .post(apiDocSoggettoUrl, this.docSoggettoActiveData)
            .then((res) => {
              console.log(res.status);
              console.log(res.data);
              this.docSoggettoActiveId = res.data.id;
              this.docSoggettoActiveData.id = res.data.id;
              this.docSoggettoFullData.push(res.data);
              // refresh grid
              this.docSoggettoFullData = [...this.docSoggettoFullData];
            });
        }
        //console.log(this.fileDocumentoActiveData)
        console.log("apro dialogI");

        this.$refs.dialogI.show();
      } else if (args.item.id === "edit") {
        // mostrare diverso dialog per visualizzazione documento
        console.log(
          "Premuto pulsante modifica documentoSoggetto allegato da gridC"
        );
        try {
          const selectedRow = this.$refs.gridC.getSelectedRecords();
          let found = false;
          this.fileDocumentoActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.fileDocumentoActiveId);
          for (const i in this.fileDocumentoFullData) {
            if (
              this.fileDocumentoFullData[i].id === this.fileDocumentoActiveId
            ) {
              // console.log("id dell'elenco trovato:")
              // console.log('FILE DOCUMENTO CORRENTE')
              // console.log(this.fileDocumentoFullData[i])
              this.fileDocumentoActiveData = {
                ...this.fileDocumentoFullData[i],
              };
              found = true;
              break;
            }
          }
          console.log("FILE DOCUMENTO SOGGETTO CORRENTE");
          console.log(this.fileDocumentoActiveData);
          if (found) {
            console.log("Edit fileDocumento allegato");
            this.$refs.dialogJ.show();
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "delete") {
        // cancellare fileDocumento selezionato
        try {
          console.log("Premuto pulsante elimina soggetto da gridC");
          const selectedRow = this.$refs.gridC.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiFileDocumentoUrl}/${deletedElementId}`;
          this.$refs.gridC.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then(() => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
            this.makeToast(
              "primary",
              "Cancellazione",
              "file allegato cancellato con successo"
            );
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
        const selectedRow = this.$refs.gridC.getSelectedRecords();
        const downloadElementUrl = selectedRow[0].fileDocumento;
        // far partire download del file ZZZ
        console.log(downloadElementUrl);
        const nomeFile = downloadElementUrl
          .split("\\")
          .pop()
          .split("/")
          .pop()
          .split("?")[0];
        this.makeToast("info", "Azione", `Apri il file ${nomeFile}`);
        // remove URL prefix and suffix from AWS filename
        console.log(`Nome file ${nomeFile}`);
        this.downloadFile(downloadElementUrl, nomeFile);
      }
    },
    // per gridB
    gridBClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "newDoc") {
        console.log(
          "Premuto pulsante creazione nuovo documentoSoggetto da gridB"
        );
        this.docSoggettoActiveId = 0;

        this.docSoggettoActiveData = this.docSoggettoDefaultData;
        this.$refs.dialogD.show(true);
      } else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica documento allegato da gridB");
        try {
          const selectedRow = this.$refs.gridB.getSelectedRecords();
          let found = false;
          this.docSoggettoActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.docSoggettoActiveId);
          for (const i in this.docSoggettoFullData) {
            if (this.docSoggettoFullData[i].id === this.docSoggettoActiveId) {
              // console.log("id dell'elenco trovato:")
              // console.log('SOGGETTO CORRENTE')
              // console.log(this.docSoggettoFullData[i])
              this.docSoggettoActiveData = { ...this.docSoggettoFullData[i] };
              found = true;
              break;
            }
          }
          console.log("DOC ALL SOGGETTO CORRENTE");
          console.log(this.docSoggettoActiveData);
          console.log(this.docSoggettoActiveId);
          if (found) {
            console.log("Edit persona fisica");
            this.$refs.dialogD.show(true);
            // Smisto in base a tipoSoggetto
            // persona fisica
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "delete") {
        console.log("Premuto pulsante cancella documento allegato da gridB");
        try {
          const selectedRow = this.$refs.gridB.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          console.log("elemento da cancellare");
          console.log(deletedElementId);
          const deleteUrl = `${apiDocSoggettoUrl}/${deletedElementId}`;
          this.$refs.gridB.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            console.log(res.data);
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
        try {
          const selectedRow = this.$refs.gridB.getSelectedRecords();
          const downloadElementId = selectedRow[0].id;
          // ZZZZ
          useJwt
            .post("/demo/api/documento/download", { id: downloadElementId })
            .then((res) => {
              console.log("gridB download get response");
              console.log(res.status);
              console.log(res.data);
            });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridBactionBegin(e) {
      if (!this.gridBFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiSoggettiUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridBFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridB.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio soggetto non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridBactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridBFlag = false;
      }
    },
    // per gridC
    gridCactionBegin(e) {},
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridCactionComplete(e) {},

    // per salvare soggetto al momento del passaggio ad un altro tab (o in caso di pressione del tasto OK)
    salvaSoggetto() {
      if (this.soggettiActiveId !== 0) {
        if (this.hasChanged) {
          // salva su remoto solo se form cambiata
          // se info modificate
          console.log("-- salvaSoggetto salva edit-- ");
          //this.soggettiActiveData.immagineProfilo="aaaa" // aggiunta simon 19/01
          const editUrl = `${apiSoggettiUrl}/${this.soggettiActiveId}`;
          useJwt.patch(editUrl, this.soggettiActiveData).then((res) => {
            console.log(this.soggettiActiveData); // aggiunta simo 19/01
            console.log(res.status);
            console.log(res.data);
          });
        } else {
          console.log("nessuna modifica");
        }
      } else {
        // salva nuovo soggetto
        console.log("-- salvaSoggetto salva nuovo-- ");
        console.log(this.soggettiActiveData);

        useJwt.post(apiSoggettiUrl, this.soggettiActiveData).then((res) => {
          console.log(res.status);
          console.log(res.data);
          this.soggettiActiveId = res.data.id;
          this.soggettiActiveData.id = res.data.id;
        });
      }
    },
    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogATab01":
          console.log("Sei nel primo tab del dialogA");
          break;
        case "dialogATab02":
          console.log("Sei nel secondo tab del dialogA");
          this.salvaSoggetto();
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    // per file upload: ?? Serve differenziarli nei vari elementi fileUpload??
    addJWTHeaders(args) {
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    onFileUpload(args) {
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    afterUpload(args) {
      console.log(args);
      if (args.name === "success") {
        console.log("tutto a posto");
        // TODO: Inserire notifica successo
      }
    },
    noop() {
      console.log("premuto enter")
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.soggettiActiveData)
      // console.log(this.soggettiSavedData)
      return Object.keys(this.soggettiActiveData).some(
        (field) =>
          this.soggettiActiveData[field] !== this.soggettiSavedData[field]
      );
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import "~@syncfusion/ej2-schedule/styles/material.css";
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}
</style>
